import { ObserveState } from "../StateManagement/ObserveState";
import { UICollapse } from "../BuildlingBlocks/UICollapse";
import { ReactNode } from "react";
import { UISpacedBoxContent } from "../BuildlingBlocks/UISpacedBoxContent";

export function PropertyEditorCollapse(props: {
    editObject: object;
    collapseLogicOrField: (() => boolean) | string;
    observeProperties?: string[];
    children: ReactNode;
    showIfFalse?: boolean;
}) {
    let listenFields: string[] = [];
    if (typeof props.collapseLogicOrField === "string") listenFields.push(props.collapseLogicOrField);

    if (props.observeProperties) listenFields.push(...props.observeProperties);

    return (
        <ObserveState
            listenTo={props.editObject}
            properties={listenFields.length === 0 ? undefined : listenFields}
            control={() => {
                let show: boolean;
                if (props.collapseLogicOrField instanceof Function) show = props.collapseLogicOrField();
                else show = Reflect.get(props.editObject, props.collapseLogicOrField);

                if (props.showIfFalse) show = !show;

                return (
                    <UICollapse in={show}>
                        <UISpacedBoxContent>{props.children}</UISpacedBoxContent>
                    </UICollapse>
                );
            }}
        />
    );
}
